import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import WhatsAppFloatButton from '../ui/WhatsAppFloatButton'
import ChatbotWidget from '../ui/ChatbotWidget'

export default function MainLayout({ transparentHeader = false }) {
  return (
    <div className="flex min-h-screen min-w-0 flex-col overflow-x-clip">
      <Header transparent={transparentHeader} />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ChatbotWidget />
      <WhatsAppFloatButton />
    </div>
  )
}
